"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErrorCountAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonErrorCount = require("../buttons/ButtonErrorCount");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonErrorCountAdapter = function ButtonErrorCountAdapter(_ref) {
  var btnText = _ref.btnText,
      type = _ref.type,
      cashbotName = _ref.cashbotName,
      getErrorMessage = _ref.getErrorMessage,
      errors = _ref.errors,
      touched = _ref.touched,
      isValid = _ref.isValid,
      submitCount = _ref.submitCount,
      iconType = _ref.iconType;
  var anyTouched = touched ? Object.keys(touched).length > 0 : false;
  var invalid = !isValid;
  var submitFailed = submitCount > 0 && !isValid;
  var errorCount = errors ? Object.keys(errors).length : 0;
  return _react.default.createElement(_ButtonErrorCount.ButtonErrorCount, {
    btnText: btnText,
    type: type,
    cashbotName: cashbotName,
    errorCount: errorCount,
    getErrorMessage: getErrorMessage,
    anyTouched: anyTouched,
    invalid: invalid,
    submitFailed: submitFailed,
    iconType: iconType
  });
};

exports.ButtonErrorCountAdapter = ButtonErrorCountAdapter;
ButtonErrorCountAdapter.defaultProps = {
  type: 'submit',
  getErrorMessage: function getErrorMessage() {},
  errors: {},
  touched: {},
  isValid: true,
  submitCount: 0,
  iconType: null
};
ButtonErrorCountAdapter.propTypes = {
  btnText: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(['button', 'submit']),
  cashbotName: _propTypes.default.string.isRequired,
  getErrorMessage: _propTypes.default.func,
  errors: _propTypes.default.object,
  touched: _propTypes.default.object,
  isValid: _propTypes.default.bool,
  submitCount: _propTypes.default.number,
  iconType: _propTypes.default.string
};